
import preSelectionBanner from 'assets/images/pre-selection-banner.png';
import sendingApplicationBanner from 'assets/images/sending-application-banner.png';
import prequalifiedApplicationBanner from 'assets/images/prequalified-application-banner.png';
import certificateBanner from 'assets/images/certificate-banner.png';

export const trainingSessions = [
  {
    title: 'Pre-Selection',
    description: 'Learn who qualifies for a FreshStart Loan',
    sessionTiming: '15 to 20 minutes',
    sessionLink: 'https://lendingusa.zohobookings.com/#/preselection',
    banner: preSelectionBanner,
  },
  {
    title: 'Sending Applications',
    description: 'Learn how to send applications through the portal',
    sessionTiming: '10 to 15 minutes',
    sessionLink: 'https://lendingusa.zohobookings.com/#/sendingapps',
    banner: sendingApplicationBanner,
  },
  {
    title: 'Pre-Qualified Applications',
    description: 'Discuss next steps after a loan gets pre-qualified',
    sessionTiming: '15 to 20 minutes',
    sessionLink: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
    banner: prequalifiedApplicationBanner,
  },
  {
    title: 'Certificate of Settlement and Refunds',
    description: 'Review the certificate of settlement process',
    sessionTiming: '10 to 15 minutes',
    sessionLink: 'https://lendingusa.zohobookings.com/#/cos',
    banner: certificateBanner,
  },
];

export const faqLeftSectionData = [
  {
    header: 'Pre-Selection',
    questions: [
      {
        id: 'preselection-1',
        question: 'Should we submit applications for both spouses or only one? What criteria should be used to determine the appropriate applicant?',
        answer: 'FreshStart Lending loans are available exclusively to individual applicants. Co-signers and co-applicants are not permitted. In cases where both spouses are enrolled in the program, it is recommended that the primary income earner be designated as the applicant, as this may enhance the likelihood of approval and increase the potential loan amount.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-2',
        question: 'What should we do if the client does not have an email address?',
        answer: 'A valid email address is required for a client to apply for a FreshStart Lending loan.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-3',
        question: 'Can clients apply if they have an existing LendingUSA loan?',
        answer: ' Yes, clients may apply for a FreshStart Lending loan; however, their current loan with LendingUSA must be in good standing.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-4',
        question: 'Are there tools available to help us pre-screen our clients?',
        answer: 'Yes, we have an internal pre-selection tool designed to assist in pre-screening clients.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-5',
        question: 'How do we incorporate our fees into the loan?',
        answer: ' Fees are added into the loan during the funding form step. There is a designated area to include the necessary fees for each settlement.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-6',
        question: 'How soon after the client is current on secured debts can they reapply?',
        answer: 'Clients can reapply as soon as their TransUnion report indicates that they are current, typically within approximately 30 to 60 days.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
      {
        id: 'preselection-7',
        question: 'Can the client update their personal contact information themselves?',
        answer: 'Clients will need to contact their debt settlement company to make any changes to their personal information in the application.',
        link: 'https://lendingusa.zohobookings.com/#/preselection',
      },
    ],
  },
  {
    header: 'Sending Applications',
    questions: [
      {
        id: 'sending-application-1',
        question: 'Should we submit applications for both spouses or only one? What criteria should be used to determine the appropriate applicant?',
        answer: 'FreshStart Lending loans are available exclusively to individual applicants. Co-signers and co-applicants are not permitted. In cases where both spouses are enrolled in the program, it is recommended that the primary income earner be designated as the applicant, as this may enhance the likelihood of approval and increase the potential loan amount.',
        link: 'https://lendingusa.zohobookings.com/#/sendingapps',
      },
      {
        id: 'sending-application-2',
        question: 'Are paper applications available?',
        answer: 'No, all applications must be completed online.',
        link: 'https://lendingusa.zohobookings.com/#/sendingapps',
      },
      {
        id: 'sending-application-3',
        question: 'What should we do if the client does not have an email address?',
        answer: 'A valid email address is required for a client to apply for a FreshStart Lending loan.',
        link: 'https://lendingusa.zohobookings.com/#/sendingapps',
      },
      {
        id: 'sending-application-4',
        question: 'Is the client required to sign up for autopay?',
        answer: 'No, clients are not required to sign up for autopay, however it is encouraged.',
        link: 'https://lendingusa.zohobookings.com/#/sendingapps',
      },
    ],
  },
];

export const faqRightSectionData = [
  {
    header: 'Pre-Qualified Applications',
    questions: [
      {
        id: 'pre-qualified-1',
        question: 'What is a CDA screenshot?',
        answer: 'A CDA screenshot is a transaction record showing the client\'s last six months of payments into their custodian account. Escrow transactions must display the client\'s name, transaction date, and "cleared" payments, including dollar amounts.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-2',
        question: 'How do I submit a funding form?',
        answer: 'A funding form is submitted through the FreshStart Lending portal once the application reaches "Pre-Qualified Status."',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-3',
        question: 'What is the difference between “Max Approval” and “Approved Amount”?',
        answer: '"Max Approval" is the total amount of funds the client needs to complete the debt settlement program, including the amount they have saved in their escrow account. An "Approval Amount" is the potential amount of funds we will loan to the client.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-4',
        question: 'Is the client required to sign up for autopay?',
        answer: 'No, clients are not required to sign up for autopay, however it is encouraged.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-5',
        question: 'When is the first payment due?',
        answer: 'The first payment is due 37 days from the date the contract is signed. Alternatively, the client can choose a first payment date within 10 days after the default first payment date.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-6',
        question: 'How long will it take for funds to be available after a client signs the loan documents?',
        answer: 'The funds will typically be available in the client’s escrow account within 5 business days of signing the loan documents. In some cases, this process can take as little as 24 hours.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-7',
        question: 'Does the client have their own portal to manage their account?',
        answer: 'Yes, clients will have access to their own portal to manage their account.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-8',
        question: 'Do you have API capabilities?',
        answer: 'Yes, we do. Please consult with your account manager, who can review all the relevant information and requirements with you.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
      {
        id: 'pre-qualified-9',
        question: 'Are we inputting the client’s personal bank account information?',
        answer: 'No, the customer’s custodian account information should be entered in the “Customer Dedicated Account” field on the funding form.',
        link: 'https://lendingusa.zohobookings.com/#/prequalifiedapps',
      },
    ],
  },
  {
    header: 'Certificate of Settlement and Refunds',
    questions: [
      {
        id: 'certificate-1',
        question: 'Can the clients keep any remaining balance?',
        answer: 'No, all residual funds must be returned to LendingUSA to be applied back to the client’s loan.',
        link: 'https://lendingusa.zohobookings.com/#/cos',
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/containers/pages/TrainingCenter/training-center-data.js